import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { UserManagementService } from '@pg-app/client/user-management/user-management.service';
import { ToastrService } from 'ngx-toastr';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';
import { DialogTypeEnum } from '@nttp/enum/common-dialog-type.enum';
import { CommonMessages } from '@pg-app/shared/constants/common-messages';

@Component({
  selector: 'np-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

  userRole = [
    {
      name: 'Administrator',
      id: 1
    },
    {
      name: 'Initiator',
      id: 2
    },
    {
      name: 'Validator',
      id: 3
    },
    {
      name: 'Read Only',
      id: 0
    },
  ];

  rows = [];

  columns = [
    {
      title: 'First name',
      name: 'firstName',
      width: '200px'
    },
    {
      title: 'Last name',
      name: 'lastName',
      width: '200px'
    },
    {
      title: 'Email',
      name: 'email',
      width: '250px'
    },
    {
      title: 'Role',
      name: 'clientRole',
      type: TableCellTypes.Dropdown,
      dropdownList: this.userRole,
      hiddenSort: true,
      hiddenFilter: true,
      width: '120px'
    }
  ];

  manageUser: FormGroup;
  isLoading = true;

  constructor(
    private fb: FormBuilder,
    private usermanagementService: UserManagementService,
    private toastr: ToastrService,
    private registerService: RegistrationStep2Service,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.manageUser = this.fb.group({
      dualAuthorization: '',
      transferDualAuthorization: true
    });

    this.getManagementData();
  }

  getManagementData() {
    this.isLoading = true;
    this.usermanagementService.getUserManagement().subscribe(res => {
      this.manageUser.get('dualAuthorization').setValue(res.dualAuthorization);
      this.manageUser.get('transferDualAuthorization').setValue(res.transferDualAuthorization);
      this.rows = res.clientRoles;
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }

  changeUserRole(event) {
    const itemChanged = this.rows.find(item => item.id === event.row.id);
    itemChanged.clientRole = parseFloat(event.value);
  }

  updateUserRole() {
    let users = [];
    this.rows.forEach(item => {
      users = users.concat({
        id: item.id,
        clientRole: item.clientRole
      });
    });
    const params = {
      dualAuthorization: this.manageUser.get('dualAuthorization').value,
      transferDualAuthorization: this.manageUser.get('transferDualAuthorization').value,
      clientRoles: users
    };
    this.usermanagementService.updateUserManagement(params).subscribe(
      data => {
        this.registerService.dualAuthorization = this.manageUser.get('dualAuthorization').value;
        this.registerService.transferDualAuthorization = this.manageUser.get('transferDualAuthorization').value;
        this.toastr.success('Updated successfully');
      },
      err => {
        const errorMess = err.error && err.error.messages && err.error.messages.length > 0 ?
          err.error.messages[0] : CommonMessages.errorMessageAPI;

        const dialogRef = this.dialog.open(CommonDialogComponent, {
          data: {
            title: errorMess,
            dialogType: DialogTypeEnum.Success
          }
        });
        dialogRef.afterClosed().subscribe(() => this.getManagementData());
      }
    );
  }
}
